export default __webpack_public_path__ + "static/media/Group 17195.a3b92f37.svg";